import { axios } from '@/utils/request2'
// /zf-cms-api/trade/accounts 账户列表
const getTradeAccounts = (params) => {
    return axios({
        url: '/app-api/stock/strategy-api/strategyPool/accountInfo',
        method: 'post',
        data: params
      })
}
// /assembly/searchstock 股票搜索
const getSearchstock = (params) => {
    return axios({
        url: '/app-api/stock/strategy-api/strategyPool/searchCode',
        method: 'post',
        data: params
    })
}
const getStockReal = (params) => {
    return axios({
        url: '/app-api/stock/market/real/time',
        method: 'post',
        data: params
    })
}

// /trade/delete 删除绑定
const getTradeDel = (params) => {
    return axios({
        url: '/trade/delete',
        method: 'post',
        data: params
      })
}
// /trade/code  获取验证码
const getCode = (params) => {
    return axios({
        url: '/trade/code',
        method: 'post',
        data: params
    })
}
// /trade/vfcode  验证验证码
const getVFCode = (params) => {
    return axios({
        url: '/trade/vfcode',
        method: 'post',
        data: params
    })
}
// /zf-cms-api/bind_account 绑定账户
const getBindAccount = (params) => {
    return axios({
        url: '/trade/bind_account',
        method: 'post',
        data: params
    })
}

const sysusersigin = (params) => {
    return axios({
        url: '/sysuser/sigin',
        method: 'post',
        data: params
    })
}
export default {
    getTradeAccounts,
    getSearchstock,
    getTradeDel,
    getStockReal,
    getCode,
    getVFCode,
    getBindAccount,
    sysusersigin
}